module.exports = __webpack_public_path__ + "media/packs/images/ship-df6811c0be2a7499d02a7684148cafc6.svg";